import React from 'react';
import styles from './IndustrialMachinery.module.css';

// Pure decoration: it never owns inventory state or intercepts interaction.
export default function IndustrialMachinery() {
  return (
    <div className={styles.machinery} aria-hidden="true">
      <div className={styles.pipe} />
      <div className={styles.piston} />
      <div className={styles.vent}><span className={styles.steam} /></div>
      <div className={styles.lights}><i /><i /><i /></div>
    </div>
  );
}
